import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import CardMedia from '@mui/material/CardMedia'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import { Avatar, IconButton, CardContent } from '@mui/material'
import { VisuallyHiddenInput } from '../../uploadFile/VisuallyHiddenFileInput'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { useDispatch } from 'react-redux'
import { setSettingsTab } from '../../../features/authSlice'

const defaultCover =
	'https://static.vecteezy.com/system/resources/previews/021/686/124/large_2x/blue-background-high-resolution-wallpaper-free-free-photo.jpg'

export const VendorPublicProfileTop = ({ handleFileChange, user }) => {
    const dispatch = useDispatch()
	return (
		<div className={styles.topContent}>
			<div className={styles.coverImgWrp}>
				<Button
					sx={{
						position: 'absolute',
						right: '2rem',
						top: '2rem',
						borderRadius: '0.5rem',
						backgroundColor: 'white',
						textTransform: 'none',
						':hover': {
							backgroundColor: '#f4f4f4ff',
						},
					}}
					component="label"
					variant="outlined"
					tabIndex={-1}
					startIcon={
						<>
							<img src="/images/camera.svg" alt="cover" />
						</>
					}
					className={styles.changeCover}
				>
					Change Cover
					<VisuallyHiddenInput
						type="file"
						accept=".jpg, .png"
						onChange={(e) => handleFileChange(e, 1)}
						multiple
					/>
				</Button>

				<CardMedia
					image={user.coverPic || defaultCover}
					className={styles.coverImg}
				/>
			</div>
			<CardContent className={styles.businessDetails}>
				<div className={styles.left}>
					<div className={styles.businessAvatar}>
						<Avatar
							src={user.businessProfilePic}
							className={styles.businessProfilePic}
						/>

						<IconButton
							className={styles.imgIcn}
							sx={{
								width: '25px',
								height: '25px',
								color: 'white',
								position: 'absolute',
								backgroundColor: '#7CA6BD',
								borderRadius: '50%',
								padding: '5px',
								right: '2rem',
								bottom: '1rem',
								':hover': {
									backgroundColor: '#6F96AB',
								},
								'@media (max-width: 1400px)': {
									right: '1rem',
									bottom: '0.5rem',
								},
							}}
							component="label"
						>
							<CameraAltOutlinedIcon />
							<VisuallyHiddenInput
								type="file"
								accept=".jpg, .png"
								onChange={(e) => handleFileChange(e, 0)}
								multiple
							/>
						</IconButton>
					</div>
					<div className={styles.businessName}>
						<Typography
							sx={{ fontWeight: 'bold' }}
							gutterBottom
							variant="h4"
						>
							{user.businessName}
						</Typography>
						<Typography color="#7ca6bd" gutterBottom variant="h6">
							{user.businessAddress}
						</Typography>
					</div>
                    <div style={{
                        display: 'flex',
                        gap: '12px'
                    }}>
                        <span
                            style={!user.topVendor ? {
                                opacity: 0.25,
                                backgroundColor: '#656565ff'
                            } : {}}
                            className={styles.topLabel}
                        >
                            <img
                                src="/images/vendor-feat-label.svg"
                                alt="vendor-feat-label.svg"
                            />
                            Top Vendor
                        </span>
                        {
                            !user.topVendor &&
                            <ButtonCustom
                                size='sm'
                                onClick={() => {
                                    dispatch(setSettingsTab(4))
                                }}
                            >
                                Upgrade to boost visibility
                            </ButtonCustom>
                        }
                    </div>
				</div>
                {
                    user?.websiteLink &&
                    <div className={styles.websiteBtn}>
                        <ButtonCustom
                            variant="outlined"
                            onClick={
                                () => window.location.assign(user?.websiteLink)
                            }
                        >
                            <img src="/images/global.svg" />
                            <Typography variant="body">Website</Typography>
                            <img src="/images/Link.svg" />
                        </ButtonCustom>
                    </div>
                }
			</CardContent>
		</div>
	)
}
